export enum ConditionLibraryModuleType {
  Default = 'Default',
  Restructuring = 'Restructuring'
}

export const ConditionLibraryModuleTypeLink: Record<ConditionLibraryModuleType, string> = {
  [ConditionLibraryModuleType.Default]: 'employment-conditions-library',
  [ConditionLibraryModuleType.Restructuring]: 'restructuring'
};
